(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-core-wager/assets/javascripts/api-calls/fetch-wager.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-core-wager/assets/javascripts/api-calls/fetch-wager.js');

'use strict';

const isServer = svs.isServer;
let logger;
let drawgamesApiCaller;
if (isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  drawgamesApiCaller = trinidadCore.components.require('tur', 'api-caller').drawgamesApiCaller;
  logger = trinidadCore.logger('numbergames:mybets-core-wager');
} else {
  drawgamesApiCaller = svs.tur.apiCaller.drawgames;
  logger = svs.numbergames.mybets_core_wager.logger;
}

async function fetchWager(_ref) {
  let {
    wagerId = '',
    req
  } = _ref;
  if (!/[0-9]+/.test(wagerId) || isServer && !req) {
    throw Error("mybets-core-wager fetchWager: Parameters \"wagerId\" ".concat(isServer ? 'and "req" are' : 'is', " mandatory!"));
  }
  try {
    const response = await drawgamesApiCaller.getPlayerWagerById({
      wagerId,
      req
    });

    return response.wager || response.response.wager;
  } catch (e) {
    if (e.code === 1) {
      logger.info("Wager not found. WagerId: ".concat(wagerId), req);
    } else {
      logger.error("Failed to fetch wager. code: ".concat(e.code, " message: ").concat(decodeURIComponent(e.message)), req);
    }
    throw Error('Error from player/wagers/wagerId');
  }
}
if (isServer) {
  module.exports = {
    fetchWager
  };
} else {
  svs.numbergames.mybets_core_wager.api_calls.fetchWager = fetchWager;
}

 })(window);